import * as React from 'react'

import { Box, Divider, Text, Title } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CostCenterAllocations } from 'modules/cost_centers/components/CostCenterAllocations'
import { LINKABLE_RESOURCES } from 'modules/cost_centers/lib/types'
import { usePerDiemWizard } from 'modules/expenses/components/expenses/New/PerDiemWizard/form/context'
import { CostCenterAllocationsChange } from 'modules/expenses/components/expenses/New/PerDiemWizard/form/types'

const RESOURCE_TYPE = 'Expenses::Expensable'

interface CostCentersProps {
  employeeId: number
}

const CostCenters = ({ employeeId }: CostCentersProps) => {
  const { data, updateData } = usePerDiemWizard()

  const resourceDate = React.useMemo(() => {
    if (data.startDate) {
      return data.startDate.toISOString().split('T')[0] ?? new Date().toISOString()
    }
    return new Date().toISOString()
  }, [data.startDate])

  const options = [
    {
      label: i18n.t('cost_centers.select_options.employee'),
      resourceType: LINKABLE_RESOURCES.Employee,
      resourceId: employeeId,
    },
  ]

  const handleChange = React.useCallback(
    (value: CostCenterAllocationsChange) => {
      updateData({ costCenters: value })
    },
    [updateData]
  )

  return (
    <Box flexDirection="column" gap="s16">
      <Box flexDirection="column" gap="s4">
        <Title
          variant="400"
          title={i18n.t('expenses_v2.forms.new_form.blocks.cost_center_information')}
        />
        <Text.Normal size="200" color="grey800">
          {i18n.t('expenses_v2.forms.new_form.blocks.cost_center_information_description')}
        </Text.Normal>
      </Box>

      <CostCenterAllocations
        resourceType={RESOURCE_TYPE}
        referenceResourceId={employeeId}
        options={options}
        resourceDate={resourceDate}
        onChange={handleChange}
        defaultSelectOption={LINKABLE_RESOURCES.Employee}
      />

      <Box paddingTop="s8" paddingBottom="s8">
        <Divider vertical={false} />
      </Box>
    </Box>
  )
}

export default CostCenters
